<template>
    <div class="container-fluid pt-5 position-relative bg-white">
        <img src="../../assets/images/landing/details-section/detail2.png" alt="" class="detail2 position-absolute"
            v-if="branding.logoImgUrl">
        <img src="../../assets/images/landing/details-section/detail3.png" alt="" class="detail3 position-absolute"
             v-if="branding.logoImgUrl">
        <div class="row pt-lg-5">
            <div class="col pb-5 text-center">
                <div class="row">
                    <h5 class="lblRed p-2 d-lg-none" :style="branding.titles">Reviews</h5>
                    <div class="col-12 col-lg-4 align-items-center d-lg-flex  justify-content-end mb-3">
                        <img src="../../assets/images/phone-frame.png" alt="" class="phone-frame position-absolute">
                        <video controls class="reel-video tagembed-container review-video mt-2" 
                               playsinline
                               preload="auto"
                               poster="../../assets/images/landing/videoFrame.png"
                               :src="useWebsiteStore.selectedVideo" id="videoReview"></video>
                    </div>
                    <div class="col-12 col-lg-8">
                        <the-video-gallery />
                    </div>
                </div>
            </div>
            <div class="col-12 pt-0">
                <reviews-card />
            </div>
        </div>
    </div>


</template>

<script>
import { useStore } from '@/store/landing';
import ReviewsCard from "@/components/landing-page/TheReviewsCard.vue"
import TheVideoGallery from '@/components/TheVideoGallery.vue';
import { useWebsiteStore } from '@/store/website';

export default {
    data() {
        return {

        }
    },
    setup() {
        return {
            websiteStore: useStore(),
            useWebsiteStore: useWebsiteStore()
        }
    },
    components: {
        ReviewsCard,
        TheVideoGallery
    },
    computed: {
        branding() {
            return this.websiteStore.getCampaignBranding(this.$route.query.utm_campaign);
        }
    },
    mounted() {

    }
}
</script>

<style scoped>

.review-video {
    position:relative;
    
    z-index: 4;
}
.lblRed {
    color: #FF1F1F;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
}

.detail2 {
    transform: scaleX(-1);
    max-width: 64px;
    top: 3px;
    left: 0px;

}

.detail3 {
    max-width: 64px;
    bottom: -30px;
    right: 0px;

}

.phone-frame {
    width: 290px;
    z-index: 0;
    height: 503px !important;
}

.review-video {
    border-radius: 29px !important;
    height: 485px;
    width: 274px;
    margin-inline:8px;
    z-index: 3;
}


/* @media (min-width: 992px) { 
    .phone-frame {
        width: 371px;
    z-index: -1;
    height: 645px!important;
}
.review-video {
    border-radius: 49px!important;
    height: 643px!important;
    width: 372px!important;
}
 } */
@media(min-width:992px) {
    .detail2 {
        transform: scaleX(-1);
        max-width: 100px;
        top: 3px;
        left: 0px;
    }

    .detail3 {
        max-width: 125px;
        width: 100px;
        bottom: -10px;
        right: -10px;
    }
}

@media (min-width: 1200px) {
    .phone-frame {
        width: 371px;
        z-index: 0;
        height: 645px !important;
    }

    .review-video {
        border-radius: 40px !important;
        height: 630px !important;
        width: 356px !important;
        z-index: 3;
    }


}
</style>